'use client';
import React, { useState, useEffect } from 'react';

export const FeatureTemplate = ({ features, description }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!features || features.length === 0) return null;

  return (
    <div className="lg:pl-[4.5rem] scroll-mt-28" id="product-features">
      <h2 className="text-2xl w-[15rem] text-[#373945] font-semibold">Features</h2>
      <p className="text-base text-[#373945] mt-4 font-450 mb-6">{description}</p>
      <p
        className="productChecklist [&_li:last-child]:mb-0"
        dangerouslySetInnerHTML={{ __html: mounted ? features : '' }}
      />
    </div>
  );
};
